import { render } from "./SignUpCompany.vue?vue&type=template&id=1e19b0ba&scoped=true&ts=true"
import script from "./SignUpCompany.vue?vue&type=script&lang=ts"
export * from "./SignUpCompany.vue?vue&type=script&lang=ts"

import "./SignUpCompany.vue?vue&type=style&index=0&id=1e19b0ba&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\devloader-userspace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e19b0ba"]])

export default __exports__